<template>
  <div
    @click="ev => $emit('click', ev)"
    @click.right="show($event)"
  >
    <slot />

    <v-menu
      v-if="!desabilitar_menu_opcoes"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <slot name="menu-de-opcoes">
        <v-list>
          <v-list-item @click="duplicarTela()">
            <v-icon>mdi-content-duplicate</v-icon>
            <p class="ma-0 ml-2">Duplicar tela</p>
          </v-list-item>
        </v-list>
      </slot>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
      showMenu: false,
      x: 0,
      y: 0,
  }),
  props: {
    desabilitar_menu_opcoes: Boolean
  },
  methods: {
    duplicarTela() {
        window.open(window.location.origin + '/dashboard', "_blank");
    },
    show(e) {
      if (this.desabilitar_menu_opcoes) return;

      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
          this.showMenu = true
      })
    }
  }
}
</script>
